import { useImperativeHandle, useRef } from "react";

import { cn } from "@virtual-brain-lib/frontend-design-system/utils";

import ScrollToBottomButton from "./ScrollToBottomButton";
import { useAutoScroll } from "./useAutoScroll";

interface AutoScrollAreaProps {
	readonly children: React.ReactNode;
	readonly ref?: React.Ref<HTMLDivElement> | undefined;
	readonly className?: string | undefined;
	readonly buttonId?: string | undefined;
	readonly isAutoScrollOnMount?: boolean;
}

export default function AutoScrollArea({
	children,
	ref: forwardedRef,
	className,
	buttonId,
	isAutoScrollOnMount,
}: AutoScrollAreaProps) {
	const innerRef = useRef<HTMLDivElement>(null!);

	useImperativeHandle(forwardedRef, () => innerRef.current);

	const { isAtBottom, scrollToBottom } = useAutoScroll(innerRef, { isAutoScrollOnMount });

	return (
		<div className="relative h-full">
			<div ref={innerRef} className={cn("h-full overflow-y-auto", className)}>
				{children}
			</div>
			<ScrollToBottomButton isAtBottom={isAtBottom} id={buttonId} onClick={scrollToBottom} />
		</div>
	);
}
